import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import ContactForm from "./ContactForm";

export default function ContactDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="contact-dialog" className="bg-cream border-navy/10 sm:max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl text-navy font-medium tracking-tight">
            Let&apos;s build <em className="italic">your product.</em>
          </DialogTitle>
          <DialogDescription className="text-charcoal/70 font-body">
            Tell us a little about your brand — we&apos;ll set up a free discovery call.
          </DialogDescription>
        </DialogHeader>
        <ContactForm onSuccess={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
